import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/icon/no-data-icon.svg';

var _hoisted_1 = /*#__PURE__*/_createVNode("div", {
  class: "no-data-title"
}, " No Data ", -1);

var _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "no-data-des"
}, " 目前沒有資料 ", -1);

var _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "no-data-icon"
}, [/*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
})], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", {
    class: ["no-data-box", [{
      'size-sm': $props.size == 'sm',
      'sty-page': $props.sty == 'page'
    }]]
  }, [_hoisted_1, _hoisted_2, _hoisted_3], 2);
}